// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { memo, useEffect, useState } from 'react'
import moment from 'moment-timezone'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { InputText } from 'ui_kit_qmd'
import {
  PERSONAL_TEXT,
  FIRST_NAME_TEXT,
  ASTERISK_TEXT,
  LAST_NAME_TEXT,
  PREFERRED_NAME_TEXT,
  DOB_TEXT,
  DATE_FORMAT_TEXT,
} from '../../../../../../utils/constants'
import { EditCardAccountInfo } from '../../../edit-card-account-info/EditCardAccountInfo'
import { setPersonalInfoState } from '../../reducers/PersonalInfoReducer'
import { DATE_FORMAT_SLASH } from '../../../../../../utils/dateUtils'

const mainInputContainerStyle = {
  width: '100%',
  marginBottom: 44,
}

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
export const EditPersonalInfoBlock = memo(({ stateInfo, dispatchInfo }) => {
  const {
    firstName,
    lastName,
    prefferedName,
    dateOfBirthValue,
    firstNameLocalError,
    lastNameLocalError,
    dateOfBirthLocalError,
  } = stateInfo

  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const id = params.get('id')

  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const patientInfo = useSelector((state) => state.chartsReducer.patientInfo)

  const currentPatientInfo = patientInfo?.[id]

  useEffect(() => {
    const prefferedNameValue = prefferedName || ''
    if (
      firstName === (currentPatientInfo?.FirstName || '') &&
      lastName === (currentPatientInfo?.LastName || '') &&
      prefferedNameValue === (currentPatientInfo?.PreferredName || '') &&
      dateOfBirthValue === moment(currentPatientInfo?.BirthDate).format(DATE_FORMAT_SLASH)
    ) {
      dispatchInfo(
        setPersonalInfoState({
          isAccountInfoChanged: false,
        }),
      )
    } else {
      dispatchInfo(
        setPersonalInfoState({
          isAccountInfoChanged: true,
        }),
      )
    }
  }, [firstName, lastName, prefferedName, dateOfBirthValue])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onChangePatientFirstName = (value) => {
    dispatchInfo(
      setPersonalInfoState({
        firstName: value,
        firstNameLocalError: '',
      }),
    )
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onChangePatientLastName = (value) => {
    dispatchInfo(
      setPersonalInfoState({
        lastName: value,
        lastNameLocalError: '',
      }),
    )
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onChangePatientPreferredName = (value) => {
    dispatchInfo(
      setPersonalInfoState({
        prefferedName: value,
      }),
    )
  }

  const onBlurDOBInput = () => {
    if (!dateOfBirthValue || dateOfBirthValue === '//') {
      dispatchInfo(
        setPersonalInfoState({
          dateOfBirthValue: moment(currentPatientInfo.BirthDate).format(DATE_FORMAT_SLASH),
        }),
      )
    }
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onChangeDOBValue = (value) => {
    const resultValuesList = []
    const separatedDOBValues = value.split('/')
    const month = separatedDOBValues?.[0]
    const date = separatedDOBValues?.[1]
    const year = separatedDOBValues?.[2]

    if (month?.length === 2) {
      if (Number(month) > 12 && (year?.length === 4 || !year?.length)) {
        resultValuesList.push('12')
      } else if (Number(month) < 1 && (year?.length === 4 || !year?.length)) {
        resultValuesList.push('01')
      } else {
        resultValuesList.push(month)
      }
    } else {
      resultValuesList.push(month)
    }

    if (date?.length === 2) {
      if (Number(date) > 31 && (year?.length === 4 || !year?.length)) {
        resultValuesList.push('31')
      } else if (Number(date) < 1 && (year?.length === 4 || !year?.length)) {
        resultValuesList.push('01')
      } else {
        resultValuesList.push(date)
      }
    } else {
      resultValuesList.push(date)
    }

    if (year?.length === 4) {
      if (Number(year) > Number(moment(new Date()).format('YYYY'))) {
        resultValuesList.push(moment(new Date()).format('YYYY'))
      } else if (Number(year) < 1901) {
        resultValuesList.push('1901')
      } else {
        resultValuesList.push(year)
      }
    } else {
      resultValuesList.push(year)
    }

    dispatchInfo(
      setPersonalInfoState({
        dateOfBirthValue: resultValuesList.join('/'),
        dateOfBirthLocalError: '',
      }),
    )
  }

  return (
    <EditCardAccountInfo title={PERSONAL_TEXT}>
      <InputText
        maxLength={35}
        containerStyle={mainInputContainerStyle}
        label={`${FIRST_NAME_TEXT}${ASTERISK_TEXT}`}
        setValue={onChangePatientFirstName}
        isError={firstNameLocalError}
        localError={firstNameLocalError}
        view='visitType'
        value={firstName}
        isDisableAutocomplete
      />
      <InputText
        maxLength={35}
        containerStyle={mainInputContainerStyle}
        label={`${LAST_NAME_TEXT}${ASTERISK_TEXT}`}
        setValue={onChangePatientLastName}
        isError={lastNameLocalError}
        localError={lastNameLocalError}
        view='visitType'
        value={lastName}
        isDisableAutocomplete
      />
      <InputText
        maxLength={50}
        containerStyle={mainInputContainerStyle}
        label={PREFERRED_NAME_TEXT}
        setValue={onChangePatientPreferredName}
        view='visitType'
        value={prefferedName}
        isDisableAutocomplete
      />
      <InputText
        mask='99/99/9999'
        containerStyle={mainInputContainerStyle}
        label={`${DOB_TEXT} ${DATE_FORMAT_TEXT}`}
        view='DOB'
        setValue={onChangeDOBValue}
        onUserBlur={onBlurDOBInput}
        value={dateOfBirthValue}
        isError={dateOfBirthLocalError}
        localError={dateOfBirthLocalError}
      />
    </EditCardAccountInfo>
  )
})
